import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { createPromise, redirectToLoginPage, getToken } from 'utils/action';
import { examIdForPracticeId } from 'common/config';
import { Modal } from '@zhike/ti-component';
import { View, Image, Button } from '@zhike/ti-ui';
import { getBodyHeight, getLogoProp } from 'utils';
import { subjectData, subjectIds } from './comment';
import styles from './styles';

const queryString = require('query-string');

const history = require('history').createBrowserHistory();

const search = global.location.search; // eslint-disable-line
const query = queryString.parse(search)
const { pid, isFull, exerciseId, from } = query
let { type } = query
if (!type) {
  type = 0
} else {
  type = parseInt(type, 10)
}
if (isFull === 'true') type = 1;


// 结束
export default class Entrance extends Component {
  // 参数
  static propTypes = {
    getExerciseList: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    logo: PropTypes.object,
  }
  static defaultProps = {
    logo: { data: {} },
  }
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      predictTime: 0,
      remainingTime: 0,
      exerciseId: 1,
      isLogin: false,
      subjects: [],
      style: {},
    };
    this.audio = null;
    this.isTry = 0;
  }

  componentDidMount() {
    const { examId } = this.props.match.params;
    const style = getBodyHeight() >= 780 ? { position: 'absolute', bottom: 0, left: 0 } : {};
    this.setState({ style });
    global.window.onresize = () => {
      if (getBodyHeight() >= 780) {
        this.setState({ style: { position: 'absolute', bottom: 0, left: 0 } });
      } else { this.setState({ style: {} }); }
    };
    global.document.title = `${examId === '56' ? '国际高中' : (examId === '2' ? 'IELTS' : 'TOEFL')}智能测评系统 - 智课`;
  }

  // 模块即将加载
  async componentWillMount() {
    // 如果新版的雅思入学测品，则不显示入口页，直接做题
    const { examId } = this.props.match.params;
    const currentPracticeId = examIdForPracticeId[type];
    if (type === 2 && examId === '2') {
      history.push(`/init/test/${currentPracticeId[examId]}${search}`);
      global.window.location.href = global.window.location.href;
    }
    if (!getToken()) {
      // 未登录，暂时显示未开始测评状态
      console.log('此用户未登录，开始做题了～～');
      this.temporaryStatus();
      return;
    }
    this.getExerciseList(getToken());
  }

  // 获取用户练习列表
  async getExerciseList(token) {
    const { getExerciseList } = this.props;
    const { examId } = this.props.match.params;
    const currentPracticeId = examIdForPracticeId[type];
    // 获取用户练习列表
    let data
    if (from !== 'smart' || exerciseId) {
      data = await createPromise(getExerciseList, {
        practicePackageId: currentPracticeId[examId],
        token,
        requireSchedule: 1,
        pid,
        exerciseId, // 如果是undefined且不是smart来源，则查询最近一次的
      });
    }
    const result = get(data, 'data');
    // 处理页面状态 数据
    let duration = 0;
    let completion;
    let resExerciseId;
    let subjects;
    if (result) {
      duration = result.duration === null ? 1800 : result.duration; // eslint-disable-line
      completion = result.completion; // eslint-disable-line
      resExerciseId = result.id;
      subjects = result.subjects; // eslint-disable-line
    }
    this.setState({
      exerciseId: resExerciseId,
      status: !result ? 'notStart' : (completion === true ? 'completed' : 'continue'), // '未开始' ‘继续测评’ ‘完成测评’
      predictTime: 30,
      remainingTime: duration && Math.floor(duration / 60),
      isLogin: true,
      subjects,
    });
  }

  // 暂时显示未开始测评
  temporaryStatus() {
    this.setState({
      status: 'notStart',
      predictTime: 30,
      isLogin: false,
    });
  }
  // 科目做题进度
  renderSubject() {
    const { examId } = this.props.match.params;
    const { subjects } = this.state;
    const currentSubjectData = subjectData[type];
    const currentSubjectIds = subjectIds[type];
    return (
      <View className={styles.subjects}>
        {
          currentSubjectData[examId] && currentSubjectData[examId].map((item, index) => {
            let completedStatus = 'notStart';
            const subject = subjects && subjects.filter(
              item => item.subjectId === currentSubjectIds[examId][index])[0];
            if (subject && subject.answerNum === 0) {
              completedStatus = 'notStart';
            } else if (subject && subject.questionNum === subject.answerNum) {
              completedStatus = 'completed';
            } else if (subject) {
              completedStatus = 'continue';
            }
            return (
              <View
                className={styles.subject}
                key={index}
              >
                {
                  item.map((subjectText, index) => {
                    if (index === 0) {
                      return (
                        <View
                          className={styles.subjectTitle}
                          key={index}
                        >
                          {subjectText}
                          <Image
                            src={
                              completedStatus === 'notStart' ? require('./assets/notStart.png') :
                              (completedStatus === 'completed' ? require('./assets/completed.png')
                              : require('./assets/continue.png'))
                            }
                            className={styles.image}
                          />
                        </View>
                    );
                    }
                    const arr = subjectText.split(' ');
                    return (
                      <View
                        className={styles.subjectItem}
                        key={index}
                      >
                        <View >{arr[0]}</View>
                        <View className={styles.num}>{arr[1]}</View>
                      </View>);
                  })
                }
              </View>
            );
          })

        }
      </View>);
  }
  // 渲染
  render() {
    const { examId } = this.props.match.params;
    const { status, predictTime, remainingTime, exerciseId, isLogin, style } = this.state;
    const { logo } = this.props;
    const currentPracticeId = examIdForPracticeId[type];
    const logoProp = getLogoProp({ image: logo.data.image, styles, className: styles.hyHeaderIcon });
    return (
      <View className={type === 1 && examId === '56' ? styles.container1 : styles.container}>
        <View className={styles.header} >
          <Image {...logoProp} />
        </View>
        <View className={styles.contentContainer}>
          <View className={styles.text}>{examId === '1' ? 'TOEFL' : (examId === '2' ? 'IELTS' : '国际高中')}智能测评系统</View>
          <View className={styles.title}>
            <View className={styles.line} />
            <View>{type !== 1 ? '精华版' : '完整版' }</View>
            <View className={styles.line} />
          </View>
          {
            type === 1 && examId === '56' &&
            <View className={styles.subTitle}>55分钟测出你的备考能力</View>
          }
          {
            (type !== 1 || examId !== '56') &&
            <View className={styles.subTitle}>
              {type !== 1 ? '30分钟' : '3小时' }测出你的{examId === '1' ? 'TOEFL' : 'IELTS'}能力
            </View>
          }
          { this.renderSubject() }
          {
              status === 'continue' && type !== 1 &&
              <View className={styles.time}>剩余用时：{remainingTime || 0}分钟</View>
          }
          {
              status === 'completed' && type !== 1 &&
              <View className={styles.time}>实际用时：{predictTime - remainingTime}分钟</View>
          }
          <View className={type === 1 && examId === '56' ? styles.buttonSenior : styles.buttons}>
            {
              status === 'notStart' &&
              <Button
                className={[styles.button, styles.notStart]}
                textClassName={styles.buttonText}
                text="开始测评"
                onClick={() => {
                  /**
                   * 登录后置 如果没有token 依旧支持做题
                   */
                  // if (!isLogin) {
                  //   redirectToLoginPage();
                  //   return false;
                  // }
                  Modal.show('ModalAlert', {
                    title: '温馨提示',
                    buttons: [{
                      title: '开始测评',
                      onClick: () => {
                        history.push(`/init/test/${currentPracticeId[examId]}${search}`);
                        global.window.location.href = global.window.location.href;
                      },
                      class: 'alertTip',
                    }],
                    width: 400,
                    isReport: true,
                    component: (
                      <View className={styles.modalAlertText}>
                        <View className={styles.alertText}>
                        1.请尽可能完成所有题目，确保测试的准确性；
                        </View>
                        <View className={styles.alertText}>2.测试过程中不支持跳题或返回上一题；</View>
                        <View className={styles.alertText}>3.可提前准备好耳机和纸笔。</View>
                      </View>
                    ),
                  });
                }
                  }
              />
            }
            {
              status === 'continue' &&
              <View className={styles.buttonC}>
                <Button
                  className={[styles.button, styles.again]}
                  textClassName={styles.buttonTextAgian}
                  text="重新测评"
                  theme="darken"
                  onClick={() => {
                    /**
                     * 登录后置 如果没有token 依旧支持做题
                     */
                    // if (!isLogin) {
                    //   redirectToLoginPage();
                    //   return false;
                    // }
                    Modal.show('ModalAlert', {
                      title: '温馨提示',
                      buttons: [{
                        title: '继续',
                        onClick: () => {
                          history.push(`/init/test/${currentPracticeId[examId]}${search}`);
                          global.window.location.href = global.window.location.href;
                        },
                        class: 'gray',
                      },
                      { title: '取消', onClick: undefined, class: 'alertTip' }],
                      width: 400,
                      isReport: true,
                      component: (
                        <View className={styles.modalAlertText}>
                          重新测评将会清除你之前的测评进度，是否继续?
                        </View>
                      ),
                    });
                  }
                    }
                />
                <Button
                  className={[styles.button, styles.continue]}
                  textClassName={styles.buttonText}
                  text="继续测评"
                  onClick={() => {
                    /**
                     * 登录后置 如果没有token 依旧支持做题
                     */
                    history.push(`/init/test/${currentPracticeId[examId]}/${exerciseId}${search}`);
                    global.window.location.href = global.window.location.href;
                    }
                  }
                />
              </View>
            }
            {
              status === 'completed' &&
              <Button
                className={[styles.button, styles.completed]}
                textClassName={styles.buttonText}
                text="查看报告"
                onClick={() => {
                  if (!isLogin) {
                    redirectToLoginPage();
                    return false;
                  }
                  history.push(`/report/test/${exerciseId}${search}`);
                  global.window.location.href = global.window.location.href;
                  }
                }
              />
            }
            {
              type === 1 && examId === '56' &&
              <View
                className={styles.question}
                onClick={() => {
                  Modal.show('ModalAlert', {
                    title: '题型规划依据',
                    isUnhide: true,
                    buttons: [{
                      title: '关闭',
                      onClick: () => {},
                      class: 'alertTip',
                    }],
                    width: 680,
                    isReport: true,
                    component: (
                      <View>
                        <View className={styles.questionText}>
                          <Image className={styles.questionIndex} src={require('./assets/1@2x.png')} />
                          题型出处：针对18年最新热门国际学校考题类型数据分析得出；
                        </View>
                        <View className={styles.questionText}>
                          <Image className={styles.questionIndex} src={require('./assets/2@2x.png')} />
                          匹配学校的出题难度：主要按照最热门学校，例如A level 类四校以及交大A level， IB类七宝德怀特、交大、平和、位育、包玉刚等；AP类星河湾、西南位育、协和万源城以及复旦 WLSA，BC类南洋模范、协和教科等学校;
                        </View>
                        <View className={styles.questionText}>
                          <Image className={styles.questionIndex} src={require('./assets/3@2x.png')} />
                          题目出处：语法题来自上海中考真题；完形填空来自上海高考真题；阅读题来自高考模拟题和托福雅思模拟题；写作根据国高常考题材分为记叙文和议论文，题目拟定来自对于历年考题的综合分析。
                        </View>
                      </View>
                    ),
                  });
                }}
              >
              查看题型规划依据
              </View>
            }
          </View>
          <Modal ref={modal => { Modal.instance = modal; }} />
        </View>
        <View
          className={styles.bottom}
          style={style}
        >
          &copy;2011-2019  北京创新伙伴教育科技有限公司|京ICP备13047080号
        </View>
      </View>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/entrance/index.js